import React , { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import { Row } from "react-bootstrap";

//
import ChangePassword from "../../../components/account/security/ChangePassword";
import ChangeEmail from "../../../components/account/security/ChangeEmail";

function Security({windowSize}) {
  const [mainCardHeight, setMainCardHeight] = useState(0);

  useEffect(() => {
    let element = document.getElementById("account");

    //
    setMainCardHeight(
      windowSize > 768 ? element.clientHeight : element.clientHeight - 38
    );
    const handleResizeWindow = () =>
      setMainCardHeight(
        windowSize > 768 ? element.clientHeight : element.clientHeight - 38
      );

    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);

    // eslint-disable-next-line
  }, []);

  return (
    <div className="security">
      <Row style={{ minHeight: `${+mainCardHeight - 69 - 80}px` }}>
        <ChangePassword />
        <ChangeEmail/>
      </Row>
    </div>
  );
}

Security.propTypes = {
  windowSize: PropTypes.number.isRequired,

};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
});

export default connect(mapStateToProps)(Security);
